var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDislikeActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1602 0.00156212H14.0402V9.36156H17.1602V0.00156212ZM0.000156403 8.58156C0.000156403 9.43956 0.702157 10.1416 1.56016 10.1416H6.48196L5.74096 13.7062L5.71756 13.9558C5.71756 14.2756 5.85016 14.572 6.06076 14.7826L6.88756 15.6016L12.02 10.4614C12.3086 10.1806 12.4802 9.79056 12.4802 9.36156V1.56156C12.4802 0.703562 11.7782 0.00156212 10.9202 0.00156212H3.90016C3.25276 0.00156212 2.69896 0.391561 2.46496 0.953161L0.109356 6.45216C0.0391559 6.63156 0.000156403 6.81876 0.000156403 7.02156V8.58156Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislikeActive);
export default __webpack_public_path__ + "static/media/dislike_active.daad62f4d8378a0ca12f8234ecc52b32.svg";
export { ForwardRef as ReactComponent };